'use strict';

var Marionette = require('backbone.marionette');
var polyglot = require('../../utilities/polyglot').default;

export default Marionette.View.extend({

  className: "timezone-notification",
  template: require('./templates/notification.hbs'),
  ui: {
    close: '.fa-close',
  },

  events: {
    'click @ui.close': 'close',
  },

  templateHelpers: function () {
    return {
      content: polyglot.t('timezone.unable_to_detect', {
        timezone: this.appointment.get('timezone_abbr'),
      }),
    };
  },

  initialize: function () {
    this.appointment = this.options.appointment;
  },

  close: function () {
    this.appointment.set('timezone_proper', true);
    this.hide();
  },

  hide: function () {
    this.$el.hide();
  },

});
